import React from 'react';
// logic
// components
import CarrierUserForm from './components/carrierUsers/carrierUserForm';
import carrierUseFormSchema from './components/carrierUsers/carrierUseFormSchema';
import carrierUserFormDefaultValues from './components/carrierUsers/carrierUserFormDefaultValues';
import ToolbarWithNoPortal from 'modules/carriersv2/toolbarWithNoPortal';
import PageContent from 'modules/emergencies/components/ui/page/pageContent';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import EditCarrierUserPageToolbar from './editCarrierUserPageToolbar';
import getCarrierUserById from './api/getCarrierUserById';
import useSWR, { mutate } from 'swr';
import updateCarrierUser from './api/updateCarrierUser';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';
import PremiumSectionContainer from 'modules/emergencies/components/ticketForm/components/PremiumSectionContainer';
import PremiumSection from 'modules/emergencies/components/ticketForm/components/PremiumSection';
import { InfoMessage } from 'modules/emergencies/components/ticketForm/components/InfoMessage';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const useEditCarriersUsersPage = ({ carrierUserId }) => {
  const history = useHistory();
  const carrierUserKey = `carrierUser-${carrierUserId}`;
  const { data: carrierUserData, error: carrierUserDataError } = useSWR(
    carrierUserKey,
    () => getCarrierUserById(carrierUserId),
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingCarrierUserData = typeof carrierUserData === 'undefined' && !carrierUserDataError;

  const onSubmit = async ({ carrierUserDto }) => {
    await updateCarrierUser({ carrierUserDto, carrierUserId });
    mutate((key) => {
      return typeof key === 'string' && key.startsWith('carrierUser-');
    });
    history.push(`/carrier/${carrierUserDto.carrier_id}/edit`);
  };
  const onCancel = () => {};

  const validationSchema = carrierUseFormSchema;
  let initialValues = { ...carrierUserFormDefaultValues };
  if (!!carrierUserData) {
    initialValues.email = carrierUserData.email;
    initialValues.first_name = carrierUserData.first_name;
    // setup phone
    initialValues.phone = carrierUserData.phone;
    if (carrierUserData.phone === undefined || carrierUserData.phone === null)
      initialValues.phone = '';
    initialValues.carrier_user_groups = carrierUserData.carrier_user_groups;
    if (carrierUserData.language !== undefined && carrierUserData.language !== null) {
      initialValues.language = carrierUserData.language;
    }
    // setup carrier user groups
    if (
      carrierUserData.carrier_user_groups === undefined ||
      carrierUserData.carrier_user_groups === null
    )
      initialValues.carrier_user_groups = [];
  }

  const isReadOnly = false;
  const isEdit = true;

  return {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    carrierUserData,
    isLoadingCarrierUserData,
    carrierUserDataError,
  };
};

const EditCarrierUserPage = ({ carrierId, carrierUserId }) => {
  const {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isLoadingCarrierUserData,
    carrierUserDataError,
  } = useEditCarriersUsersPage({ carrierUserId });

  const carrierUserFormData = {
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
    carrierId,
  };

  const isPageReady = !isLoadingCarrierUserData;
  const is404Error = carrierUserDataError?.code === 404;

  return (
    <>
      <Layout>
        <ToolbarWithNoPortal>
          <EditCarrierUserPageToolbar carrierId={carrierId} />
        </ToolbarWithNoPortal>
        <PageContent>
          {!isPageReady ? (
            <BasicLoader />
          ) : carrierUserDataError ? (
            <PremiumSectionContainer>
              <PremiumSection>
                <InfoMessage>
                  {is404Error ? 'User not found' : 'There was an error loading the user'}
                </InfoMessage>
              </PremiumSection>
            </PremiumSectionContainer>
          ) : (
            <>
              <CarrierUserForm carrierUserFormData={carrierUserFormData} />
            </>
          )}
        </PageContent>
      </Layout>
    </>
  );
};

export default EditCarrierUserPage;
